export default __webpack_public_path__ + "static/media/adam_icon.b31fc7fc.png";